import { Component } from '@angular/core';
import { ScheduledChannelSnapshotRunStatusType } from 'dashboard/enums/scheduled-channel-snapshot-run-status-type.enum';
import { ScheduledChannelSnapshot } from 'dashboard/interfaces/scheduled-channel-snapshot.interface';
import { BaseDataGridCellRenderer } from 'shared/abstract/base-data-grid-cell-renderer';
import { TooltipDirective } from 'shared/directives/tooltip.directive';
import { SharedModule } from 'shared/shared.module';

const runStatusTypeTranslationMap = {
    [ScheduledChannelSnapshotRunStatusType.UNKNOWN]: '',
    [ScheduledChannelSnapshotRunStatusType.PROCESSING]: 'dashboard.scheduledReports.table.runStatus.processing',
    [ScheduledChannelSnapshotRunStatusType.SUCCESSFUL]: 'dashboard.scheduledReports.table.runStatus.success',
    [ScheduledChannelSnapshotRunStatusType.PARTIALLY_SUCCESSFUL]: 'dashboard.scheduledReports.table.runStatus.partiallysuccessful',
    [ScheduledChannelSnapshotRunStatusType.FAILED]: 'dashboard.scheduledReports.table.runStatus.failed',
};

@Component({
    selector: 'app-scheduled-channel-snapshots-run-status-cell-renderer',
    templateUrl: './scheduled-channel-snapshots-run-status-cell-renderer.component.html',
    styleUrls: ['./scheduled-channel-snapshots-run-status-cell-renderer.component.scss'],
    imports: [SharedModule, TooltipDirective],
})
export class ScheduledChannelSnapshotsRunStatusCellRendererComponent extends BaseDataGridCellRenderer {
    public status: string = '';
    public isStatusActionable: boolean = false;
    public messages?: string[];
    public areMessagesOpen: boolean = false;

    constructor() {
        super();
    }

    public onDataChange(): any {
        const data = (this.data as unknown as ScheduledChannelSnapshot).lastRunStatus;

        this.status = runStatusTypeTranslationMap[data.status];
        this.isStatusActionable =
            (data.status === ScheduledChannelSnapshotRunStatusType.FAILED ||
                data.status === ScheduledChannelSnapshotRunStatusType.PARTIALLY_SUCCESSFUL) &&
            (!!data.warnings || !!data.errors);
        this.messages = [...(data.errors ?? []), ...(data.warnings ?? [])];
    }

    public openMessages(numberOfMessages: number) {
        if (numberOfMessages === 0) {
            return;
        }

        this.areMessagesOpen = true;
    }

    public closeMessages() {
        this.areMessagesOpen = false;
    }
}
